import { render, staticRenderFns } from "./SupportWidget.vue?vue&type=template&id=8e4bb92c&scoped=true&"
import script from "./SupportWidget.vue?vue&type=script&lang=js&"
export * from "./SupportWidget.vue?vue&type=script&lang=js&"
import style0 from "./SupportWidget.vue?vue&type=style&index=0&id=8e4bb92c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4bb92c",
  null
  
)

export default component.exports